<script setup lang="ts">
import { computed, ref } from 'vue'

import { injectEventIncidentsQueue } from '@desktop/views/Relation/provide-inject'

import QueueErrorButton from './QueueErrorButton.vue'

interface Props {
  withQueueBlockedText: boolean
}

defineProps<Props>()

// inject
const eventIncidentsQueue = injectEventIncidentsQueue()

// state
const errorQueueIncidentsCount = ref(0)

// computed
const hasQueueError = computed(() => errorQueueIncidentsCount.value > 0)

// init
eventIncidentsQueue.subscribeOnChange(({ errorQueueIncidents }) => {
  errorQueueIncidentsCount.value = errorQueueIncidents.length
})
</script>

<template>
  <QueueErrorButton :hasQueueError>
    <span class="w-4 text-xs">{{ errorQueueIncidentsCount }}</span>
    <span class="px-0.25 text-xs">!</span>
  </QueueErrorButton>
  <QueueErrorButton
    v-if="withQueueBlockedText"
    class="px-2"
    :hasQueueError
  >
    QUEUE BLOCKED
  </QueueErrorButton>
</template>
